import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { settingsApi } from '../api'
import type { CaseMembership, LakeGrant } from '../types'

interface AsyncList<T> {
  items: T[]
  loading: boolean
  error: string | null
}

/** Loads the current user's case memberships and data-lake grants. */
export function useAccessData() {
  const { t } = useTranslation()
  const [memberships, setMemberships] = useState<AsyncList<CaseMembership>>({
    items: [],
    loading: true,
    error: null,
  })
  const [lakeGrants, setLakeGrants] = useState<AsyncList<LakeGrant>>({
    items: [],
    loading: true,
    error: null,
  })

  useEffect(() => {
    settingsApi
      .getMemberships()
      .then(items => setMemberships({ items, loading: false, error: null }))
      .catch(() =>
        setMemberships({
          items: [],
          loading: false,
          error: t('settings.access.caseMemberships.error'),
        })
      )

    settingsApi
      .getLakeGrants()
      .then(items => setLakeGrants({ items, loading: false, error: null }))
      .catch(() =>
        setLakeGrants({ items: [], loading: false, error: t('settings.access.dataLake.error') })
      )
  }, [t])

  return { memberships, lakeGrants }
}
